import React, { useEffect, useState } from "react";
import backicon from './../../../../../../Assets/icons/backIcon.svg'
import "./index.scss";
import { useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API"; 
import Loader from "../../../../../customComponents/CustomLoader";
import Swal from "sweetalert2";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";


const AddSeatingCapacity = () => {
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("businessPartnerId")

  useEffect(() => {
    userTypedropdown()
  },[])

  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      })

      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    // Validate required fields
    UnitInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }

    const confirmation = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);
        const payload = {
  seating_capacity: formData.seatingcapacity,
  seating_capacity_desc: formData.description,
          status: formData.status === "Active" ? 1 : 0,
        };
        if (userType === "superadmin") {
          payload.business_partner_id = formData.business_partner_id;
        } else {
          payload.business_partner_id = businessPartnerId;
        }
        const response = await axiosInstance.post('/seatcapacity/create', payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        if (response.status === 200) {
          await Swal.fire({
            title: "Success",
            text: "Seating Capacity added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });
          navigate(ROUTES_NAVIGATION.SEATINGCAPACITYLIST);
        }
  
      } catch (error) {
        console.error('Error adding unit:', error);
        const errorMessage = error.response?.data?.message || "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false); 
    }
  };
  

  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.SEATINGCAPACITYLIST);
  };

  const UnitInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
            validation: { required: true}
          },
        ]
      : []),
    {
      name: "seatingcapacity",
      label: "Seating Capacity",
      placeholder:"Enter Seating Capacity",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true,
        pattern: /^[0-9\s]*$/,
        message: "Only digits are allowed",
        maxLength:2
       },
    },
    {
      name: "description",
      label: "Description",
      placeholder:"Enter  Description",
      type: "text",
      required: true,
      gridClass: "col-lg-4",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { id: 1, label: "Active", value: "Active" },
        { id: 0, label: "Inactive", value: "Inactive" },
      ],
      gridClass: "col-lg-4",
      validation: { required: true },
    },
  ];

  return (
    <>
      <div>
    {loading ? ( 
      <Loader />
    ) : (
      <><div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Seating Capacity</span>
            </div><div className="form-container">
                <span className="cust-det-title mt-2 mb-2">
                  Please Enter Seating Capacity Details
                </span>
                <DynamicForm
                  formConfig={UnitInputs}
                  formData={formData}
                  setFormData={setFormData}
                  onSubmit={handleFormSubmit}
                  validationErrors={validationErrors}
                  setValidationErrors={setValidationErrors} />
              </div><div className="btncontainer mt-3">
                <button
                  onClick={() => handleFormSubmit(formData)}
                  className="submit-btn"
                >
                  Submit
                </button>
              </div></>
    )}
    </div>
    </>
  );
};

export default AddSeatingCapacity;
